import { language as lan_address } from "./address";
import { language as lan_list } from "./list";
import { language as lan_bankTransfer } from "./bank-transfer";
import { language as lan_reordermodel } from "./reorder-model";
import { language as lan_transfervoucher } from "./transfer-voucher";

let language = {
    ...lan_address,
    ...lan_list,
    ...lan_bankTransfer,
    ...lan_reordermodel,
    ...lan_transfervoucher,
    // 获取银行转账信息审核状态-失败提示
    ORDER_DETAIL_GET_BANK_TRANSFER_FAILED_TITLE: "Offline payment status issue",
    ORDER_DETAIL_GET_BANK_TRANSFER_FAILED_CONTENT: "Anomaly in querying offline payment status, Please try again. If the issue persists, contact our support team at {{supportmail}}.",
    // 订单不存在
    "A107B500201": "The order you're looking for could not be found, or the order ID is incorrect. If this issue persists, please contact our support team at {{supportmail}}.",
    // 非线下交易订单
    "A107B5400010": "This order is not a bank transfer order. If this issue persists, please contact our support team at {{supportmail}}."

}

export { language }